const EVENTS = {
  SIGNUP: {
    GO_TO_PRIVACY: 'signup.go_to_privacy',
    ACCEPTED_PRIVACY: 'signup.accepted_privacy',
    REFUSED_PRIVACY: 'signup.refused_privacy',
    CREATE_USER: 'signup.create_user',
    USERTYPE_SELECTED: 'signup.usertype_selected',
  },
  SIGNIN: {
    LOGGEDIN: 'signin.loggedin',
  },
  USER: {
    PROFILE_UPDATED: 'user.profile_updated',
  },
  SEARCH: {
    RUN: 'search.run',
    CHANGE_PAGE: 'search.change_page',
    APPLY_FILTER: 'search.apply_filter',
    SELECT_CATEGORY: 'search.select_category',
    SELECT_SUBCATEGORY: 'search.select_subcategory',
    VIEW_PROFILE_FROM_CARD: 'search.view_profile_from_card',
    VIEW_PROFILE_FROM_SEARCHBAR: 'search.view_profile_from_searchbar',
  },
  CALL: {
    START_FROM_PROFILE: 'call.start_from_profile',
    START_FROM_CARD: 'call.start_from_card',
  },
}

export default EVENTS
